
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/counselling/[slug]",
      function () {
        return require("private-next-pages/counselling/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/counselling/[slug]"])
      });
    }
  